"use strict";

exports.__esModule = true;
exports.RadioGroupRoot = exports.RadioRoot = void 0;

var _themes = require("../themes");

var _Choice = _interopRequireWildcard(require("../Choice"));

var _themes2 = require("./themes");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var RadioRoot = (0, _themes.themed)(_Choice.default)(function (_ref) {
  var baseTheme = _ref.theme;
  return (0, _themes.mapComponentThemes)({
    name: 'Radio',
    theme: (0, _themes2.radioTheme)(baseTheme)
  }, {
    name: 'Choice',
    theme: {}
  }, baseTheme);
});
exports.RadioRoot = RadioRoot;
var RadioGroupRoot = (0, _themes.themed)(_Choice.ChoiceGroup)(function (_ref2) {
  var baseTheme = _ref2.theme;
  return (0, _themes.mapComponentThemes)({
    name: 'RadioGroup',
    theme: (0, _themes2.radioGroupTheme)(baseTheme)
  }, {
    name: 'ChoiceGroup',
    theme: {}
  }, baseTheme);
});
exports.RadioGroupRoot = RadioGroupRoot;